import { Address } from "../../api/types/generated-types";
import { AddressOption, LocationOptionTypeEnum } from "../../types/AddressOption";

export function normalizeAddressOption(address: Partial<Address>): AddressOption {
  const optionType = address.id ? LocationOptionTypeEnum.Platform : LocationOptionTypeEnum.GooglePlaces;
  return { ...address, optionType };
}
